var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReceiveMoneyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_35342_362166)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 6.59375H8C7.56875 6.59375 7.21875 6.94375 7.21875 7.375V8.03125C7.2375 8.025 7.25 8.01875 7.26875 8.0125C7.34375 7.975 7.425 7.95 7.50625 7.925C7.54375 7.9125 7.58125 7.9 7.625 7.8875C7.75 7.8625 7.875 7.84375 8.00625 7.84375H13.0063C13.1375 7.84375 13.2625 7.8625 13.3875 7.8875C13.425 7.89375 13.4625 7.9125 13.5062 7.925C13.5875 7.95 13.6688 7.975 13.7438 8.0125C13.7625 8.01875 13.7813 8.025 13.7938 8.03125V7.375C13.7813 6.94375 13.4313 6.59375 13 6.59375Z",
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 8.78125H8C7.56875 8.78125 7.21875 9.13125 7.21875 9.5625V9.875H8.9375C9.19375 9.875 9.40625 10.0875 9.40625 10.3438C9.40625 10.9437 9.9 11.4375 10.5 11.4375C11.1 11.4375 11.5938 10.9437 11.5938 10.3438C11.5938 10.0875 11.8063 9.875 12.0625 9.875H13.7812V9.5625C13.7812 9.13125 13.4313 8.78125 13 8.78125Z",
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 4.5625H8C7.56875 4.5625 7.21875 4.9125 7.21875 5.34375V5.85C7.45625 5.73125 7.71875 5.65625 8 5.65625H13C13.2812 5.65625 13.5437 5.73125 13.7812 5.85V5.34375C13.7812 4.9125 13.4313 4.5625 13 4.5625Z",
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1188 1.75H7.88125C5.60625 1.75 4.25 3.10625 4.25 5.38125V10.6125C4.25 12.8938 5.60625 14.25 7.88125 14.25H13.1125C15.3875 14.25 16.7437 12.8938 16.7437 10.6188V5.38125C16.75 3.10625 15.3938 1.75 13.1188 1.75ZM14.875 10.8125H14.25H12.475C12.2625 11.7063 11.4563 12.375 10.5 12.375C9.54375 12.375 8.7375 11.7063 8.525 10.8125H6.75H6.125C5.86875 10.8125 5.65625 10.6 5.65625 10.3438C5.65625 10.0875 5.86875 9.875 6.125 9.875H6.28125V9.5625V9.25V7.375V5.34375C6.28125 4.39375 7.05 3.625 8 3.625H13C13.95 3.625 14.7188 4.39375 14.7188 5.34375V7.375V9.25V9.5625V9.875H14.875C15.1313 9.875 15.3438 10.0875 15.3438 10.3438C15.3438 10.6 15.1313 10.8125 14.875 10.8125Z",
    fill: "#F6F8FA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_35342_362166",
    x: -1,
    y: 0.5,
    width: 23,
    height: 23,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_35342_362166"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_35342_362166",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiveMoneyIcon);
export default __webpack_public_path__ + "static/media/receiveMoneyIcon.da97aa1986a266f5ca3eef4aa32906da.svg";
export { ForwardRef as ReactComponent };